import { createSlice } from '@reduxjs/toolkit';

import { commonState } from './commonStateValue';

const commonSlice = createSlice({
    name: 'common',
    initialState: commonState,
    reducers: {
        exceptionHandlerRequest: (state, action) => {
            return {
                ...state,
                exception: {
                    error: action.payload,
                },
            };
        },
    },
});

export { commonSlice };
